import { Timeline as AntdTimeline } from 'antd';
import type { ReactNode } from 'react';

import { UserAvatar } from '@/components/common/user-avatar';

import styles from './timeline.module.scss';

export type TimelineStatus = 'info' | 'success' | 'error' | 'pending';

export type TimelineItem = {
  status: TimelineStatus;
  title: ReactNode;
  person?: { name: string; avatarSrc?: string };
  timestamp?: ReactNode;
};

export type TimelineProps = {
  items: TimelineItem[];
  className?: string;
};

export function Timeline({ items, className }: TimelineProps) {
  return (
    <AntdTimeline
      className={[styles.timeline, className].filter(Boolean).join(' ')}
      items={items.map((item) => ({
        dot: <span className={[styles.dot, styles[item.status]].join(' ')} />,
        children: (
          <div className={styles.content}>
            <div className={styles.left}>
              <span className={[styles.title, styles[item.status]].join(' ')}>{item.title}</span>
              {item.person ? (
                <div className={styles.person}>
                  <UserAvatar name={item.person.name} src={item.person.avatarSrc} size={18} />
                  <span className={styles.name}>{item.person.name}</span>
                </div>
              ) : null}
            </div>
            {item.timestamp ? <span className={styles.timestamp}>{item.timestamp}</span> : null}
          </div>
        ),
      }))}
    />
  );
}
